/** API route map: URLS.Controller.EmployeeOnboarding */
export const EmployeeOnboarding = {
      Name: 'EmployeeOnboarding/',
      // EN-29808 - has the admin re-opened this packet, how complete is it, and what may be edited.
      GetOnboardingResendStatus: 'get-onboarding-resend-status',
      // EN-29808 - name/username for the side menu while onboarding is still open.
      GetOnboardingProfileHeader: 'get-onboarding-profile-header',
      GetInitialQuestionnaire: 'get-initial-questionnaire',
      AddInitialQuestion: 'add-initial-question',
      UpdateInitialQuestion: 'update-initial-question-requirement',
      DeleteInitialQuestions: 'delete-initial-questions',
      AddTask: 'add-task',
      GetTask: 'get-task',
      DeleteTask: 'delete-task',
      UpdateEmployeeOnboarding: 'update-employee-onboarding',
      GetEmployeeOnboarding: 'get-employee-onboarding',
      GetSavedW4: 'get-saved-w4',
      AddDirectDeposit: 'add-direct-deposit',
      GetDirectDeposit: 'get-direct-deposit',
      DeleteDirectDeposit: 'delete-direct-deposit',
      AddW4: 'add-w-4',
      DeleteW4: 'delete-w-4',
      AddForm: 'add-form',
      DeleteI9: 'delete-i-9',
      // EN-29808 — ported for the Forms tab (I-9 family, same values as PEO).
      UpdateEmployeeI9: 'update-i9',
      // EN-29808 — ported for the Forms tab (W-4 family, same values as PEO). Note the
      // misspelled `Sginature` key is PEO's; kept verbatim so the two codebases stay greppable.
      UpdateEmployeeW4: 'update-w4',
      UpdateEmployeeW4Sginature: 'update-w4-signature',
      GetEmployeeOnboardingByTemplate: 'get-employee-onboarding-by-template',
      // EN-29808 — ported for the Forms tab (Direct Deposit, same value as PEO).
      UpdateEmployeeDd: 'update-dd',
      // EN-29808 — ported for the Forms tab (dynamic custom onboarding forms, same values as PEO).
      addEmployeeClientCustom: 'add-employee-client-custom-form',
      getEmployeeTypeByClient: 'get-employment-type-by-client',
      saveOnboardingCustomFillableForm: 'save-onboarding-custom-fillable-form',
      // EN-29808 — ported for the Forms tab (state tax forms, same value as PEO).
      UpdateEmployeeStateTax: 'update-state-tax',
      // EN-29808 - Embedded Videos step, ported from PEO.
      GetTemplateVideos: 'get-template-videos',
      UpdateStepVideo: 'update-step-video',
      // EN-18096 - counts a page whose Save & Next was pressed with nothing changed.
      CompletePage: 'complete-page',
};
